export default __webpack_public_path__ + "upload-contact.svg";